module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABFElEQVRIie2WMUoDQRSGv1ljYqHY2tiLlYUI2nkCEcFzWHgAPUDAPpW9J/AAdrmHpe6CEhE+m4lOkd2omx2C+MPCv4+d9/HYmZ9B7atDtbQ7lZHRJ5pcGga1BDbIoyqoZoIBUOSELS1wkhN4HkJYA04XBWzaNJMIA0B9AjbbApsmHKiX6pZ6sQgYNE/Yieb9w+Pkmeo2qT0CN8AOsA4cAPeNHZtyqOa7q6R2NKNfTx3X9fzNOfzcSCGEB/VMvVa3Y+09Tj1TvTZA9RC4i697wEn047rFbZNmP/G7iX/pCriS+NXvLFjKLP0H/kjzou058dMsfQNeox/wdUwEyugLaq4tS5elfwNYZeRVBTDKCBxh5qv+B8+42nIROnxDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/linkedin.png
// module id = 874
// module chunks = 93